import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { MY_IABLUE_ASSISTANT_ID } from '../lib/constants';
import type {
  PromptDraftResponse,
  UpdatePromptDraftRequest,
} from '@/types/api/prompt-versions';

const DRAFT_QUERY_KEY = ['prompt-draft', MY_IABLUE_ASSISTANT_ID];

/**
 * Hook to fetch the prompt draft for My IABlue assistant
 */
export function usePromptDraft() {
  return useQuery<PromptDraftResponse>({
    queryKey: DRAFT_QUERY_KEY,
    queryFn: async () => {
      const { data } = await api.get<PromptDraftResponse>(
        `/assistants/${MY_IABLUE_ASSISTANT_ID}/prompt/draft`
      );
      return data;
    },
  });
}

/**
 * Hook to update the prompt draft
 */
export function useUpdatePromptDraft() {
  const queryClient = useQueryClient();

  return useMutation<PromptDraftResponse, Error, UpdatePromptDraftRequest>({
    mutationFn: async (dto) => {
      const { data } = await api.put<PromptDraftResponse>(
        `/assistants/${MY_IABLUE_ASSISTANT_ID}/prompt/draft`,
        dto
      );
      return data;
    },
    onSuccess: (data) => {
      // Update cache with new draft data
      queryClient.setQueryData(DRAFT_QUERY_KEY, data);
    },
  });
}

/**
 * Query key for draft - exported for cache invalidation
 */
export const PROMPT_DRAFT_QUERY_KEY = DRAFT_QUERY_KEY;
